// apps/nos/client/src/components/Workbench/Skeletons.tsx
//
// Lightweight skeleton placeholders for WorkbenchPage's three columns while
// useFlavorSession is in flight.

export function IngredientSearchSkeleton() {
  return (
    <div className="panel" style={{ padding: 12, height: "100%" }}>
      <div className="skeleton-line" style={{ width: "60%", height: 18 }} />
      <div style={{ height: 12 }} />
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="skeleton-line"
          style={{ width: "100%", height: 28, marginBottom: 6 }}
        />
      ))}
    </div>
  );
}

export function FlaskPanelSkeleton() {
  return (
    <div className="panel" style={{ padding: 12, height: "100%", flex: 1 }}>
      <div className="skeleton-line" style={{ width: "40%", height: 18 }} />
      <div style={{ height: 12 }} />
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="skeleton-line"
          style={{ width: "100%", height: 32, marginBottom: 6 }}
        />
      ))}
    </div>
  );
}

export function SensoryRailSkeleton() {
  return (
    <div className="panel" style={{ padding: 12, height: "100%" }}>
      <div className="skeleton-line" style={{ width: "55%", height: 18 }} />
      <div style={{ height: 12 }} />
      <div
        className="skeleton-line"
        style={{ width: "100%", height: 220 }}
      />
      <div style={{ height: 12 }} />
      <div
        className="skeleton-line"
        style={{ width: "100%", height: 180 }}
      />
    </div>
  );
}
